import React, { useState } from "react";
import { useForm } from "react-hook-form";
import {
  Grid,
  Paper,
  Typography,
  Card,
  CardActionArea,
  CardMedia,
  CardContent,
} from "@material-ui/core";
import { getCleanedString } from "../../../services/utils";
import { Link } from "react-router-dom";

export default function EventsFinder(props) {
  const { icon, callback, events } = props;

  const { register, handleSubmit } = useForm();
  const [searchText, setSearchText] = useState("");

  const findRegistry = (value) => {
    let ValorBuscado = value;
    let listaEventos = [];

    if (ValorBuscado === "") return null;

    if (events && ValorBuscado.length > 2) {
      ValorBuscado = getCleanedString(ValorBuscado);
      const nombreBuscado = ValorBuscado.toUpperCase();

      for (const i in events) {
        const value = events[i];
        if (value?.nombreEvento) {
          const valueToFind = `${value.nombreEvento} ${value.fechaEvento} ${value.ciudadEvento} ${value.iDEvento} ${value.lugarEvento} ${value.paisEvento} ${value.tipoDeEvento} ${value.businessId || ""}`;
          const nombreComparar = getCleanedString(valueToFind.toUpperCase());
          if (nombreComparar.match(nombreBuscado) !== null) {
            listaEventos.push(value);
          }
        }
      }
    }

    return listaEventos;
  };

  const handleChange = (e) => {
    const texto = e.target.value;
    setSearchText(texto); // actualiza estado del input
    const resultados = findRegistry(texto);
    if (callback) callback(resultados);
  };

  // === Eventos Cercanos ===
  const hoy = new Date();
  console.log("hoy", hoy);
  hoy.setHours(0, 0, 0, 0); // ← ahora incluye todos los eventos de hoy
  console.log("hoy", hoy);
  const diaActual = hoy.getDay();
  const fechaSabadoPasado = new Date(hoy);
  fechaSabadoPasado.setDate(hoy.getDate() - diaActual - 1);
  const fechaDomingoPasado = new Date(hoy);
  fechaDomingoPasado.setDate(hoy.getDate() - diaActual);

  const eventosOrdenados = events
    ? Object.values(events)
      .filter((e) => e.fechaEvento)
      .sort((a, b) => new Date(a.fechaEvento) - new Date(b.fechaEvento))
    : [];

  const proximosEventos = eventosOrdenados.filter((e) => {
    const fecha = new Date(e.fechaEvento + "T00:00:00");
    fecha.setHours(0, 0, 0, 0); // ← también normaliza la fecha del evento
    if (e.iDEvento === 572) {
      console.log("hoy", hoy, "fecha", fecha, hoy === fecha, e.iDEvento);

    }

    return fecha >= hoy && fecha <= new Date(hoy.getTime() + 7 * 24 * 60 * 60 * 1000);
  });

  const eventosFinDeSemanaPasado = eventosOrdenados.filter((e) => {
    const fecha = new Date(e.fechaEvento);
    return (
      fecha.toDateString() === fechaSabadoPasado.toDateString() ||
      fecha.toDateString() === fechaDomingoPasado.toDateString()
    );
  });

  const renderEventosCards = (lista) =>
    lista.map((evento, idx) => (
      <Grid item xs={12} sm={6} md={4} lg={3} key={idx}>
        <Card>
          <CardActionArea component={Link} to={`/eventos-organizados/evento_${evento.iDEvento}`}>
            {evento.logoEvento && (
              <CardMedia
                component="img"
                height="140"
                image={evento.logoEvento}
                alt={evento.nombreEvento}
              />
            )}
            <CardContent>
              <Typography variant="h6">{evento.nombreEvento}</Typography>
              <Typography variant="body2" color="textSecondary">
                {evento.ciudadEvento} - {evento.fechaEvento}
              </Typography>
            </CardContent>
          </CardActionArea>
        </Card>
      </Grid>
    ));

  return (
    <>
      <Paper style={{ padding: 20, margin: 20, backgroundColor: "#e0e0e0" }}>
        <Grid container direction="row" justifyContent="space-evenly" alignItems="center">
          <Grid item xs={12}>
            <Typography variant="h4" color="primary" align="center">
              Buscador de Eventos
            </Typography>
          </Grid>
          <Grid item xs={12}>
            <Typography variant="h6" align="center">
              Puedes buscar por nombre, lugar, tipo de evento, fecha (AAAA-MM-DD).
            </Typography>
          </Grid>
          <Grid item xs={8}>
            <form onSubmit={handleSubmit(() => { })}>
              <input
                onChange={handleChange}
                name="nameOrNumber"
                defaultValue=""
                style={{ fontSize: 30, width: "100%" }}
                ref={register}
              />
            </form>
          </Grid>
        </Grid>
      </Paper>

      {searchText.trim() === "" && (
        <>
          {proximosEventos.length > 0 && (
            <div style={{ padding: "0 20px" }}>
              <Typography variant="h5" style={{ marginBottom: 16 }}>
                Próximos eventos
              </Typography>
              <Grid container spacing={2}>{renderEventosCards(proximosEventos)}</Grid>
            </div>
          )}

          {eventosFinDeSemanaPasado.length > 0 && (
            <div style={{ padding: "40px 20px 20px" }}>
              <Typography variant="h5" style={{ marginBottom: 16 }}>
                Eventos del fin de semana pasado
              </Typography>
              <Grid container spacing={2}>{renderEventosCards(eventosFinDeSemanaPasado)}</Grid>
            </div>
          )}
        </>
      )}
    </>
  );
}
